// extracted by mini-css-extract-plugin
export default {"navbar":"Navstyles_navbar__y2fDQ","navContent":"Navstyles_navContent__cU+bp","navLink":"Navstyles_navLink__7FpzY","active":"Navstyles_active__w1rVz"};